module.exports = __webpack_public_path__ + "files/d852698c3f8b022bbaab4f9c37609f3a.png";